<template>
  <b-button v-if="!$store.state.isLoggedIn && !$store.state.isLoginProcessing" id="login" data-id="login"
    v-bind="$attrs"
    @click="login(redirect_uri)" class="has-text-weight-bold" rounded>{{
      $t('login') }}
  </b-button>
  <!-- login ボタンコンポーネントで Loading 処理を設定する -->
  <div v-if="$store.state.isLoginProcessing" class="custom-loading">
    <img src="/static/images/loading.svg" alt="loading">
  </div>
</template>

<script>
export default {
  name: "ButtonLogin",
  inheritAttrs: false,
  props: {
    redirect_uri: {
      type: String,
      default: '/dashboard'
    }
  },
}
</script>

<style lang="scss" scoped>
.custom-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
